import fetchHandler from "../../utils/fetchHandler";
import { MY_HISTORY } from "../types/actions";

export const getSummary = (queryString = "") => {
	const fetchOptions = {
		url: `/api/history_summary${queryString}`,
		method: "GET",
		actionType: MY_HISTORY.GET_SUMMARY
	};
	return fetchHandler(fetchOptions);
};

export const getDetails = (queryString) => {
	const fetchOptions = {
		url: `/api/log_exercises${queryString}`,
		method: "GET",
		actionType: MY_HISTORY.GET_DETAILS
	};
	return fetchHandler(fetchOptions);
};
